import { render } from "./AddScheduleModal.vue?vue&type=template&id=24ea38ef&scoped=true&ts=true"
import script from "./AddScheduleModal.vue?vue&type=script&lang=ts"
export * from "./AddScheduleModal.vue?vue&type=script&lang=ts"

import "./AddScheduleModal.vue?vue&type=style&index=0&id=24ea38ef&lang=scss&scoped=true"
import "./AddScheduleModal.vue?vue&type=style&index=1&id=24ea38ef&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ea38ef"]])

export default __exports__